import { createContext, useContext } from 'react';
import { AppointmentDetail } from 'types/api/appointments';

/**
 * Lifts the appointment detail fetch into a parent-owned context so
 * every sub-component (Details / StatusSelect / StateModal / etc.)
 * can read the same row + trigger a refresh after its own mutation.
 * REST equivalent of the legacy useQuery(GET_APPOINTMENT_ITEM,
 * fetchPolicy: cache-only) + client.refetchQueries cycle.
 *
 * Mirrors cycle-21 DoctorProfileContext.
 */
export interface AppointmentDetailContextValue {
  appointment: AppointmentDetail | null;
  loading: boolean;
  refresh: () => void;
}

export const AppointmentDetailContext = createContext<
  AppointmentDetailContextValue | undefined
>(undefined);

export const useAppointmentDetail = (): AppointmentDetailContextValue => {
  const ctx = useContext(AppointmentDetailContext);

  if (!ctx) {
    throw new Error(
      'useAppointmentDetail must be used inside an AppointmentDetailContext.Provider'
    );
  }

  return ctx;
};
